import "./LoginFormController.scss"
import { classNames } from 'primereact/utils'
import React, { useState } from 'react'
import { Controller } from 'react-hook-form'
import { ReactComponent as ShowPassword } from "./assets/ShowPassword.svg"
import { ReactComponent as HidePassword } from "./assets/HidePassword.svg"
import { useToggle } from '../../../hooks'


function LoginFormController({ name, icon, control, rules, label, id, enableShowPassword }) {
  const [showPassword, setShowPassword] = useToggle(true)
  const [value, setValue] = useState('')

  

  return (
    <div className="LoginFormController">
      <div className="InputContainer flex justify-content-between align-items-center p-3" onClick={() => {
        document.getElementById(`${id}`).focus()
      }} >
        <div className=" flex w-full" >
          {icon}
          <div className="Border mx-2" ></div>
          <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field: { ...field } }) =>
              <>
                <input {...field}
                  className="InputElement text-lg w-full"
                  type={showPassword && enableShowPassword ? 'password' : 'text'}
                  id={id}
                  onChange={e => {
                    field.onChange(e)
                    setValue(e.target.value)
                  }}
                />
                <label className={classNames('Label font-bold', { Active:  value })}>{label}</label>
              </>
            }
          />
        </div>
        {enableShowPassword &&
          <div className='z-1 cursor-pointer' onClick={setShowPassword}>
            {!showPassword && <HidePassword />}
            {showPassword && <ShowPassword />}
          </div>
        }
      </div>

    </div>
  )
}

export default LoginFormController